module.exports = __webpack_public_path__ + "img/40f94035-052d-4375-b9b6-8eb7fcf19ef6.19e63470.png";